import { Breakpoint, ColumnMax } from "./CSSGrid.types";

const maxColumns: {
  [key in Breakpoint]: ColumnMax;
} = {
  all: 12,
  largeMobile: 12,
  smallTablet: 12,
  tablet: 12,
  smallDesktop: 12,
  desktop: 12,
  largeDesktop: 12,
};

export const info = {
  maxColumns,
} as const;
